<template>
  <span>
    {{amount.amount}} {{currencySign}}
  </span>
</template>

<script>
    export default {
        name: 'pretty-amount',
        props: {
            amount: {
                type: Object,
            },
        },
        data() {
            return {}
        },
        computed: {
            currencySign() {
                switch (this.amount.currency) {
                    case 'rub':
                        return '₽';
                    case 'usd':
                        return '$';
                    default:
                        return this.amount.currency
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Ui/PrettyAmount.vue